module.exports = __webpack_public_path__ + "img/IMG_0079_FoamcoreMatted.efd5faa5.jpg";